import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { RootState } from "../../../Shared/React/store/rootReducer";
import { actions, ErrorState } from "../store/error";

class ErrorHandler extends React.Component<ErrorHandlerProps> {
    public render(): JSX.Element {
        return (this.props.errorHandler.showError &&
            <div onClick={() => this.props.clearError()} className="alert alert-danger" role="alert">
                <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                <span className="sr-only">Error:</span>
            {this.props.errorHandler.message} ({this.props.errorHandler.status}: {this.props.errorHandler.statusText})
        </div>
        );
    }
}

const mapStateToProps = (state: RootState): ErrorProps => {
    return {
        errorHandler: state.errorHandler,
    };
};

export interface ErrorProps {
    errorHandler: ErrorState;
}

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
    return {
        clearError: (): Action => dispatch(actions.clearError()),
    };
};

interface DispatchProps {
    clearError: () => Action;
}

export interface ErrorHandlerProps extends DispatchProps, ErrorProps {
}

export default connect(mapStateToProps, mapDispatchToProps)(ErrorHandler);
